<template>
  <div>
    <div class="qa-operation-area">
      <template v-if="$permission('ticket:edit')">
        <div class="flex" style="justify-content: flex-start;"> 
          <template v-if="data.status === mailTypeStatusEnum.DONE">
            <gj-button class="color333" type="text" @click="updateStatus(mailTypeStatusEnum.PENDING)">
              <div class="flex align-center">
                <img src="../../../../../assets/images/crm/processed.png" alt=""><span>标记待处理</span>
              </div>
            </gj-button>
          </template>
          <template v-if="data.status === mailTypeStatusEnum.PENDING">
            <gj-button type="text" class="color333" @click="updateStatus(mailTypeStatusEnum.DONE)">
              <div class="flex align-center">
                <img src="../../../../../assets/images/crm/clock.png" class="gj-mr4" alt="">标为已处理
              </div>
            </gj-button>
          </template>
          <gj-button
            class="color333"
            type="text"
            @click="setStarMark">
            <div class="flex align-center">
              <img v-if="!data.isStar" src="../../../../../assets/images/crm/collection.png" class="gj-pointer gj-mr4">
              <img v-else src="../../../../../assets/images/crm/collection2.png" class="gj-pointer gj-mr4">
              <span>{{!data.isStar?'': '取消'}}标记重要邮件</span>
            </div>
          </gj-button>
        </div>
        <gj-button class="gj-mr14" @click="operationLog" style="height: 32px;">操作日志</gj-button>
      </template>
    </div>
    <div class="qa-layout"
      v-loading="loading"
      element-loading-spinner="not"
      element-loading-background="rgba(255, 255, 255, 0.8)"
  >
    <div class="qa-email">
      <el-row>
        <el-col :span="16">
          <span class="color333 weight600 gj-mr4">{{data.emailName}}</span>
          <span class="color999 gj-mr8">&lt;{{isMeaningful(item) ? item.emailAddress || '-' : '-'}}&gt;</span>
          <i class="iconfont iconcollection size14"></i>
          <div style="height: 18px;margin-bottom: 4px;"><span class="color666" style="margin-right: 12px">邮件主题</span><span class="color999">{{data.subject||'-'}}</span></div>
        </el-col>
        <el-col :span="8" style="text-align: right" class="color666">
          <span style="display: grid; align-items: center;">
            {{isMeaningful(item) ? item.lastTime : '-'}}
          </span>
        </el-col>
      </el-row>
    </div>
    <div class="qa-content">
      <div class="qa-content-listing">
        <div>
          <gj-image :size="40" :src="data.imageUrl"></gj-image>
        </div>
        <div class="listing-detail">
          <div>
            <gj-tooltip :text-line="2" :content="data.listingTitle">{{data.listingTitle || '-'}}</gj-tooltip>
          </div>
          <div style="margin-top: 4px">
            <span class="color666">ASIN</span>
            <span class="color444" style="margin-left: 10px">
              <a :href="data.asinUrl" target="_blank">{{data.asin || '-'}}</a>
            </span>
          </div>
        </div>
      </div>
      <div class="qa-content-detail">
        {{data.question}}
      </div>
    </div>
  </div>
  </div>
</template>

<script>
  import {getQAEmailDetail,setTicketCollection,updateStatus} from "../../../../../api/crm";
  import {isMeaningful} from "../../../../../utils/common";
  import {mailTypeEnum, mailTypeStatusEnum} from "./enum";
  import {isMeaningfulMixin} from "../../../../../minxins";

  export default {
    name: "app-mail-reply-qa-content",
    mixins: [isMeaningfulMixin],
    props: {
      item: {},
      marketId: null,
      mailType: null,
    },
    watch: {
      item: {
        immediate: true,
        deep: true,
        handler(value) {
          this.data = {};
          if (isMeaningful(value) && this.mailType === mailTypeEnum.QA) {
            this.loading = true;
            getQAEmailDetail(value.id)
              .then((data) => {
                this.data = data;
              }).complete(() => this.loading = false)
          }
        }
      }
    },
    data() {
      return {
        loading: false,
        mailTypeEnum,
        mailTypeStatusEnum,
        data: {},
      }
    },
    methods: {
      // 设置为重要图标
      setStarMark() {
        let params = {
          ticketIds: [this.data.id],
          type: !this.data.isStar ? 1 : 0
        }
        setTicketCollection(params).then(res => {
          this.$gjMessage.success(res.data);
          this.loading = true;
          getQAEmailDetail(this.data.id)
            .then((data) => {
              this.data = data;
            }).complete(() => this.loading = false)
          this.$emit('closeReview');
        })
      },
      // 查看日志
      operationLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: `/crm/ticket/${this.data.id}/logs`,
            columns: [
              {id: 'createTime', header: '操作时间', field: 'createTime', minWidth: '120px', sortable: true},
              {id: 'opUser', header: '操作用户', field: 'slot:userName', minWidth: '100px'},
              {id: 'content', header: '操作内容', field: 'content', overflowLine: 2,  minWidth: '100px'}
            ]
          }
        })
      },
      //标记跟踪、处理
      updateStatus(status) {
        updateStatus(this.data.id, status)
          .then(() => {
            this.$gjMessage.success('操作成功');
            // 刷新未处理邮件数量接口
            this.data.status = status;
            this.$emit('closeReview');
            // this.tabClick()
          }).complete(() => this[status + 'Loading'] = false)
      },
    }
  }
</script>

<style scoped>
  .qa-operation-area {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 46px;
      line-height: 46px;
      background: #F6F8FB;
      border-radius: 0px 2px 0px 0px;
      border-bottom: 1px solid #E4E5E6;
    }
  .qa-layout {
    width: 100%;
    height: 100%;
    flex-direction: column;
    display: flex;
  }
  .qa-layout a {
    cursor:pointer;
    color: #1F6EEF;
    text-decoration: unset;
  }
  .qa-content {
    flex: 1;
    overflow-y: hidden;
    padding: 12px 30px 20px 8px;
  }
  .qa-content-listing {
    display: flex;
    flex-direction: row;
  }
  .listing-detail {
    flex: 1;
    margin-left: 10px;
  }
  .qa-content:hover {
    overflow-y: overlay;
  }
  .color666 {
    color: #666;
  }
  .color444 {
    color: #333;
  }
  .qa-email {
    margin-left: 10px;
    padding-top: 10px;
    margin-right: 10px;
    border-bottom: 1px solid #ddd;
    height: 55px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }
  .qa-content-detail {
    margin-top: 12px;
    white-space: pre-wrap;
    padding: 8px 20px 6px 13px;
    border-radius: 4px;
    background: #EEF3FB;
  }
</style>
